/*eslint no-useless-escape: "off"*/
export default function eclPasswordValidator(string, username) {
   //PROPS:
   //string - string - to be validated with password rules
   //username - string - required to validate if the user being assigned the PW is using the username in PW

   const rExLength = ".{8,}"; // at least 8 characters
   const rExLowercase = "(?=(.*[a-z]){1,})"; // one+ lower case character
   const rExUppercase = "(?=(.*[A-Z]){1,})"; // one+ uppercase character
   const rExNumeric = "(?=(.*[0-9]){1,})"; // one+ numeric
   const rExSpecialChar = /[!@#\$%\^\&\*\(\)\+\.\-\_,\?]/g; // one+ special character

   let validationObj = {
      inputValid: true,
      validationRules: {
         lengthValid: {
            passed: RegExp(rExLength).test(string),
            message: "at least 8 characters",
         },
         lowercaseValid: {
            passed: RegExp(rExLowercase).test(string),
            message: "1 lowercase",
         },
         uppercaseValid: {
            passed: RegExp(rExUppercase).test(string),
            message: "1 uppercase",
         },
         numericValid: {
            passed: RegExp(rExNumeric).test(string),
            message: "1 number",
         },
         specialCharValid: {
            passed: rExSpecialChar.test(string),
            message: "1 symbol",
         },
         excludeUsernameValid: {
            passed: !string.includes(username),
            message: "Cannot include username.",
         },
      },
   };

   for (let rule in validationObj.validationRules) {
      if (!validationObj.validationRules[rule].passed) {
         validationObj.inputValid = false;
         break;
      }
   }

   return validationObj;
}
